import CompanySettingsSetup from "./settings/setup";
import CompanySettingsPermissions from "./settings/permissions";
// @ts-ignore
import CompanySettingsModules from "./modules/modules";
import CompanySettingsStorage from "./settings/storage";
import Modules from "../../modules/modules";
import ProjectAccessSettings from "./project-access/project-access";
import CompanyRoleSettings from "./company-role/company-role";
import WorkWeekSchedule from "../../model2/work-week-schedule/work-week-schedule"
import CompanySettingsWorkSchedule from "./work-schedule/work-schedule"
import CompanySettingsFields from "./settings/fields";
import CrmSettings from "./settings/crm/crm";

// const debug = "CompanySettings"
const debug = false

export default class CompanySettings {

    public companyId            : ID

    public labs                 : any
    public modules              : CompanySettingsModules
    public permissions          : CompanySettingsPermissions
    public viewTemplates        : any
    public workSchedule!        : CompanySettingsWorkSchedule
    public defaultAccess        : any
    public setup                : any
    // public fields               : any
    public fields               : CompanySettingsFields
    public storage              : CompanySettingsStorage
    public crm                  : CrmSettings
    public _modulesConfig       : any

    public projectAccess        : ProjectAccessSettings
    public companyRole          : CompanyRoleSettings


    constructor(companyId:ID, data:any) {

        // data = companyProperties.settings (!)

        debug && console.log(debug,'.constructor', data);

        this.companyId = companyId;

        this._init(data);

        this.permissions    = new CompanySettingsPermissions(data.permissions);
        this.storage        = new CompanySettingsStorage(_.get(data,'storage', {}));
        this.projectAccess  = new ProjectAccessSettings(_.get(data,'projectAccess', {}));
        this.companyRole    = new CompanyRoleSettings(_.get(data,'companyRole', {}));

        this.fields         = new CompanySettingsFields(_.get(data,'fields', {}))
        this.crm            = new CrmSettings(_.get(data,'crm', {}))
    }

    _init(data:any) {

        // MODULES
        this._modulesConfig = _.get(data,'modulesConfig',{})

        // kogda menyatusytsya company settings nam nado re-init modules...
        if (gd.modules && this.companyId === gd.companyId) {

            gd.modules = new Modules(this._modulesConfig)

            // // tut nuansi est' v shared view ...
            // if (gd.isSharedView) {
            //     gd.modules = new Modules(this._modulesConfig)
            // } else {
            //     if (this.companyId === gd.companyId) {  // mi vseh companies init settings to delaem...
            //         gd.modules = new Modules(this._modulesConfig)
            //     }
            // }
        }
        // END MODULES

        // THIS IS OLD MODULES !!!
        this.modules        = new CompanySettingsModules(_.get(data,'modules',{}));

        this.viewTemplates  = _.get(data, 'viewTemplates', []); // see manage view templates (!) class ViewTemplates


        this.labs = {
            planning                        : {
                autoScheduleNewTasks    : _.get(data, 'labs.planning.autoScheduleNewTasks', true),
                autoScheduleUpdatedTasks: _.get(data, 'labs.planning.autoScheduleUpdatedTasks', true),
            },
            timeReport                      : {
                reportingLimit          : _.get(data, 'labs.timeReport.reportingLimit', false),
                reportingDays           : _.get(data, 'labs.timeReport.reportingDays', 30),
                reportingLimitManager   : _.get(data, 'labs.timeReport.reportingLimitManager', false),
                reportingDaysManager    : _.get(data, 'labs.timeReport.reportingDaysManager', 30),
            },
            myWorkAssigned                  : _.get(data, 'labs.myWorkAssigned', false),
            multipleTaskProjectsSupport     : _.get(data, 'labs.multipleTaskProjectsSupport', true),
            strictWorkflow                  : _.get(data, 'labs.strictWorkflow', false)
        };

        this.workSchedule   = new CompanySettingsWorkSchedule(data.workSchedule)
        this.defaultAccess  = _.get(data, 'defaultAccess', gd.const.company.defaultAccess.NONE);

        this.setup = new CompanySettingsSetup(data.setup);

        // this.fields = {
        //     storyPoints:        _.get(data, 'fields.storyPoints', storyPointsDefaultOptions),
        // }
    }

    get workWeekSchedule(): WorkWeekSchedule {
        return this.workSchedule.workWeekSchedule
    }

    async save() {return gd.api.Company.saveSettings(this.companyId, this.toJSON()).promise()}

    toJSON() {
        return {
            labs                : this.labs,
            modules             : this.modules.toJSON(),
            permissions         : this.permissions.toJSON(),
            viewTemplates       : this.viewTemplates,
            workSchedule        : this.workSchedule.toJSON(),
            defaultAccess       : this.defaultAccess,
            setup               : this.setup.toJSON(),
            // fields              : this.fields,
            fields              : this.fields.toJSON(),
            storage             : this.storage.toJSON(),
            crm                 : this.crm.toJSON(),
            projectAccess       : this.projectAccess.toJSON(),
            companyRole         : this.companyRole.toJSON(),
            modulesConfig       : this._modulesConfig
        }
    }
}
